import {
  Button,
  H3,
  Modal,
  P,
  PropsModal,
  lightTheme,
} from '@vgrubs/components';

export const DeleteCategoryModal = ({
  deleteModal,
  closeModal,
  handleDeleteCategory,
}: PropsModal & {
  deleteModal: boolean;
  handleDeleteCategory: () => void;
}) => {
  return (
    <Modal isOpen={deleteModal} closeModal={closeModal} logo={false}>
      <H3 $mb="24" $color={lightTheme.primary}>
        Are you sure
      </H3>
      <P $mb="40">
        Are you sure you want to delete this category? <br /> This will delete
        items within the category as well.
      </P>

      <Button $selected $w="100%" $mb="8" onClick={handleDeleteCategory}>
        Confirm
      </Button>

      <Button $selected $w="100%" $gray onClick={() => closeModal?.()}>
        Cancel
      </Button>
    </Modal>
  );
};
